
		<h1>
			Access denied! - 403 error!
		</h1>
	
		May be, you need
	
		<a
			*ngIf="authService.isAuth; else login"
			routerLink="/sign_out"
		>
			relogin
		</a>
		for access
	
		<ng-template #login>
			<a
				class="btn btn-primary"
				routerLink="/sign_in"
				role="button"
			>
				login
	        </a>
	</ng-template>
	